var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube11(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.1759 10.3979C38.7147 8.68438 37.3637 7.33367 35.6505 6.87225C32.5203 6.01562 19.9996 6.01562 19.9996 6.01562C19.9996 6.01562 7.47922 6.01562 4.34904 6.8396C2.66875 7.30071 1.28478 8.68468 0.823666 10.3979C0 13.5278 0 20.0189 0 20.0189C0 20.0189 0 26.5426 0.823666 29.6398C1.28509 31.353 2.63579 32.7041 4.34935 33.1655C7.51218 34.0221 19.9999 34.0221 19.9999 34.0221C19.9999 34.0221 32.5203 34.0221 35.6505 33.1981C37.364 32.737 38.7147 31.386 39.1762 29.6728C39.9998 26.5426 39.9998 20.0518 39.9998 20.0518C39.9998 20.0518 40.0328 13.5278 39.1759 10.3979Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0132 26.0154L26.4249 20.0187L16.0132 14.022V26.0154Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube11);
export default __webpack_public_path__ + "static/media/youtube11.095d4fb7bfd997c3676732e3fc3b1e59.svg";
export { ForwardRef as ReactComponent };